import useState from 'rc-util/lib/hooks/useState';
import * as React from 'react';
import Button from '../button';
import { convertLegacyProps } from '../button/button';
function isThenable(thing) {
    return !!(thing && thing.then);
}
const ActionButton = (props) => {
    const { type, children, prefixCls, buttonProps, close, autoFocus, emitEvent, isSilent, quitOnNullishReturnValue, actionFn, } = props;
    const clickedRef = React.useRef(false);
    const buttonRef = React.useRef(null);
    const [loading, setLoading] = useState(false);
    const onInternalClose = (...args) => {
        close === null || close === void 0 ? void 0 : close(...args);
    };
    React.useEffect(() => {
        let timeoutId = null;
        if (autoFocus) {
            timeoutId = setTimeout(() => {
                var _a;
                (_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            });
        }
        return () => {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
        };
    }, []);
    const handlePromiseOnOk = (returnValueOfOnOk) => {
        if (!isThenable(returnValueOfOnOk)) {
            return;
        }
        setLoading(true);
        returnValueOfOnOk.then((...args) => {
            setLoading(false, true);
            onInternalClose(...args);
            clickedRef.current = false;
        }, (e) => {
            // See: https://github.com/ant-design/ant-design/issues/6183
            setLoading(false, true);
            clickedRef.current = false;
            // Do not throw if is `await` mode
            if (isSilent === null || isSilent === void 0 ? void 0 : isSilent()) {
                return;
            }
            return Promise.reject(e);
        });
    };
    const onClick = (e) => {
        if (clickedRef.current) {
            return;
        }
        clickedRef.current = true;
        if (!actionFn) {
            onInternalClose();
            return;
        }
        let returnValueOfOnOk;
        if (emitEvent) {
            returnValueOfOnOk = actionFn(e);
            if (quitOnNullishReturnValue && !isThenable(returnValueOfOnOk)) {
                clickedRef.current = false;
                onInternalClose(e);
                return;
            }
        }
        else if (actionFn.length) {
            returnValueOfOnOk = actionFn(close);
            // https://github.com/ant-design/ant-design/issues/23358
            clickedRef.current = false;
        }
        else {
            returnValueOfOnOk = actionFn();
            if (!returnValueOfOnOk) {
                onInternalClose();
                return;
            }
        }
        handlePromiseOnOk(returnValueOfOnOk);
    };
    return (React.createElement(Button, Object.assign({}, convertLegacyProps(type), { onClick: onClick, loading: loading, prefixCls: prefixCls }, buttonProps, { ref: buttonRef }), children));
};
export default ActionButton;
